<template>
  <q-list
    no-border
    link
  >
    <q-list-header>
      {{ $t('label.downloadTickets') }}
    </q-list-header>
    <q-item
      v-for="(ticket, index) in filterLinkList"
      :key="index"
      v-close-overlay
      :data-test="CypressTarget('Download')"
      @click.native="download(ticket.link, ticket.type)"
    >
      <q-item-main label>
        {{ ticket.type }}
      </q-item-main>
    </q-item>
  </q-list>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import { i18n } from 'plugins/language/i18n';

  export default {
    name: 'ActionListDownload',
    props: {
      linkList: {
        type: Array,
        required: true,
      },
    },
    computed: {
      ...mapGetters('settings', [
        'getIntiModule',
      ]),
      filterLinkList() {
        return this.linkList.filter((ticketLink) => {
          if (this.getIntiModule === 'ticket') {
            return ticketLink.type.toLowerCase() !== 'email';
          }

          return this.getIntiModule === 'subscription' && ticketLink.type.toLowerCase() === 'email';
        });
      },
    },
    methods: {
      ...mapActions('subscription', [
        'getCardFromEmail',
      ]),
      async download(link, type) {
        if (type.toLowerCase() === 'email') {
          const data = await this.getCardFromEmail({ linkEmail: link });
          const title = i18n.t('modal.subscription.downloadTicket.ticketByEmail.title');
          let message = i18n.t('modal.subscription.downloadTicket.ticketByEmail.msg');
          if (!data.result) {
            message = i18n.t('modal.subscription.downloadTicket.ticketByEmail.error');
          }

          this.$q.dialog({
            title,
            message,
            timeout: 5000,
            color: this.SET_COLOR.primary,
            ok: true,
            preventClose: true,
            noBackdropDismiss: true,
            noEscDismiss: true,
          });
        } else {
          this.$emit('download', { link, type });
        }
      },
    },
  };
</script>
